
















import { Prop, Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app'

@Component({
  components: {
  }
})
export default class Impressum extends Vue {
  @Prop() public isDesktop!: boolean

  get footerLinks() {
    return AppModule.session.footerLinks
  }
}
